<section class="report-window" [class.is-loading]="loading()">
  <header class="window-title">
    <i class="bi bi-exclamation-triangle-fill"></i>
    <div>
      <span>Reportes</span>
      <h1>Reporte de precios atípicos</h1>
    </div>
  </header>

  <div class="content">
    @if (loading()) {
      <app-loading-overlay [message]="loadingMessage()" />
    }

    <p class="subtitle">Identifica cotizaciones fuera del porcentaje de variación seleccionado.</p>

    <div class="filters">
      <div class="field">
        <label for="fechaInicial">Fecha inicial</label>
        <input id="fechaInicial" type="date" [(ngModel)]="fechaInicial" />
      </div>

      <div class="field">
        <label for="fechaFinal">Fecha final</label>
        <input id="fechaFinal" type="date" [(ngModel)]="fechaFinal" />
      </div>

      <div class="field percentage-field">
        <label for="porcentajeVariacion">Porcentaje de variación</label>
        <input id="porcentajeVariacion" type="number" min="0" step="1" [(ngModel)]="porcentajeVariacion" />
      </div>
    </div>

    @if (message()) {
      <p class="notice">{{ message() }}</p>
    }

    <div class="actions">
      <button class="secondary" type="button" [disabled]="loading()" (click)="preview()">
        <i class="bi bi-eye me-1"></i>Previsualizar
      </button>
      <button class="primary" type="button" [disabled]="loading()" (click)="exportExcel()">
        <i class="bi bi-file-earmark-excel me-1"></i>Generar Excel
      </button>
    </div>

    @if (previewOpen() && hasRows()) {
      <section class="preview-panel" aria-labelledby="previewTitle">
        <div class="preview-title">
          <div>
            <h2 id="previewTitle">Previsualización de precios atípicos</h2>
            <span>{{ rows().length }} registro(s) encontrado(s) · Período {{ previewRangeLabel() }}</span>
          </div>
          <button class="close-preview" type="button" aria-label="Cerrar previsualización" (click)="closePreview()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="ag-theme-quartz report-grid">
          <ag-grid-angular
            style="width: 100%; height: 100%;"
            [rowData]="rows()"
            [columnDefs]="previewColumnDefs()"
            [defaultColDef]="defaultColumnDef"
            [pagination]="true"
            [paginationPageSize]="50"
            [paginationPageSizeSelector]="[10, 25, 50, 100]"
            [animateRows]="true" />
        </div>
      </section>
    }
  </div>
</section>
